<template lang="pug">
.tip-container(v-if="show", @touchmove.prevent)
  .tip-dialog
    .close-icon(@click="closeModal")
    .main-title 确定要退款吗？
    .sub-title 退款后30个自然日内不支持再次退，若您领取了权益也将收回！
    .know-btn
      .know-btn-left(@click="goRefund") 直接退款
      .know-btn-right(@click="closeModal") 我再想想
  .shadow
</template>
<script>
import { env } from '@hb/hbridge';
import { UBT } from '@hb/tianqi/lib/ubt.h5';
import { userCancelVip } from '@/api/vip';
import config from '@/const/config';
import Toast from '@/components/toast';
import { getSystemCode } from '@/utils/systemCode';
import {
  getTokenAndKey,
} from '@/utils';
import { redirectToCardComplete } from '@/utils/vip';
import { ANCHOR_MAP } from '../../consts';

export default {
  props: {
    mainTitle: {
      type: String,
      default: '',
    },
    subTitle: {
      type: String,
      default: '',
    },
    show: {
      type: Boolean,
      default: false,
    },
    isNewMember: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      env,
      redirectUrl: '',
      isnew: null,
      isRefunding: false, // 添加防重复点击标志
    };
  },
  watch: {
    isNewMember(val) {
      this.isnew = val;
    },
  },
  methods: {
    closeModal() {
      this.$emit('update:show', false);
    },
    async goRefund() {
      UBT.clickButton({
        pageId: 'platform_openedcard_page',
        buttonName: 'platform_Double_confirmation_refund',
        categoryId: 'platform',
        businessInfo: {},
      });
      // 防止重复点击
      if (this.isRefunding) {
        return;
      }
      this.isRefunding = true;
      const { token } = await getTokenAndKey();
      try {
        const res = await userCancelVip({
          token,
          appCode: 'platform',
        });
        if (res.code === 0) {
          Toast.show('退款成功');
          if (this.isNewMember) {
            await redirectToCardComplete({
              extraParams: ['token'], // 微信小程序跳转会丢失token，需要保留
              fixedParams: {
                newTabCode: ANCHOR_MAP.VIP, // 会员退卡后，如果不传newTabCode，会默认跳转到单车页面，体验不好
              },
            });
          } else {
            const urlInfo = window.location.href;
            if (urlInfo.includes('m2')) {
              this.redirectUrl = `https://m.hellobike.com/AppPlatformH5/${config.env !== 'pro' ? `${config.env}/` : ''}latest/index.html#/vip/v2/transfer?systemCode=${getSystemCode()}`;
            } else {
              this.redirectUrl = `https://m2.hellobike.com/AppPlatformH5/${config.env !== 'pro' ? `${config.env}/` : ''}latest/index.html#/vip/v2/transfer?systemCode=${getSystemCode()}`;
            }
            window.location.replace(this.redirectUrl);
            // this.$router.push({
            //   path: '/vip/v2/transfer',
            //   query: {
            //     systemCode: getSystemCode(),
            //   },
            // });
          }

          this.closeModal();
        }
      } catch (e) {
        Toast.show(e);
      } finally {
        this.isRefunding = false;
      }
    },
  },
};
</script>
<style lang="less" scoped>
.tip-container {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 330;

  .tip-dialog {
    height: 2rem;
    position: relative;
    width: 3.2rem;
    background-color: #fff;
    border-radius: 12px;
    z-index: 332;
    text-align: center;
    font-family: PingFangSC-Medium, PingFang SC, sans-serif;

    .main-title {
      padding: 0.28rem 0.28rem 0;
      font-size: 0.2rem;
      font-weight: 500;
      color: #242729;
      line-height: 0.25rem;
    }

    .sub-title {
      margin-top: 0.16rem;
      padding: 0 0.24rem;
      font-size: 0.14rem;
      font-weight: 400;
      color: #5a6066;
      line-height: 0.2rem;
      font-family: PingFangSC, PingFang SC, sans-serif;
    }

    .know-btn {
      margin-top: 0.24rem;
      display: flex;
      justify-content: space-between;
      padding: 0 0.16rem;

      .know-btn-left {
        width: 1.4rem;
        height: 0.4rem;
        background: #f3f3f4;
        border-radius: 0.08rem;
        font-family: PingFangSC, PingFang SC, sans-serif;
        font-weight: 400;
        font-size: 0.16rem;
        color: #5a6066;
        line-height: 0.4rem;
        text-align: center;
      }

      .know-btn-right {
        width: 1.4rem;
        height: 0.4rem;
        background: linear-gradient(90deg, #fa8621 0%, #fa3a00 100%);
        border-radius: 0.08rem;
        font-family: PingFangSC, PingFang SC, sans-serif;
        font-weight: 500;
        font-size: 0.16rem;
        color: #fff;
        line-height: 0.4rem;
        text-align: center;
      }
    }

    .close-icon {
      position: absolute;
      background-image: url(https://m.hellobike.com/resource/helloyun/15979/HP3T5BQrkn.png);
      background-repeat: no-repeat;
      background-size: 100% 100%;
      width: 0.16rem;
      height: 0.16rem;
      top: 0.12rem;
      right: 0.12rem;
    }
  }

  .shadow {
    position: fixed;
    z-index: 331;
    width: 100%;
    height: 100%;
    background: #000;
    opacity: 0.7;
  }
}
</style>
